import { ReactNode } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { Link } from "@/libraries/design/components";

import { useAccountCreationContext } from "../../hooks";

export const Error = ({ errorText }: { errorText?: ReactNode }) => {
    const intl = useIntl();
    const { formError } = useAccountCreationContext();
    if (!formError) {
        return null;
    }
    if (errorText === undefined) {
        errorText = intl.formatMessage(
            {
                id: "BxpUiSignup.SignupForm.formError",
                defaultMessage:
                    "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
            },
            {
                contactUsLink: (text: ReactNode) => (
                    <Link
                        text={text as unknown as string}
                        aria-label={text as unknown as string}
                        type="inline"
                        href="/company/contact"
                        className="linkText"
                    />
                )
            }
        );
    }
    return (
        <p css={errorCss} role="alert">
            {errorText}
        </p>
    );
};

const errorCss = css({
    color: `${token("color.icon.accent.red")} !important`,
    margin: "1rem 0",
    textWrap: "pretty"
});
